import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { EditGenericDocumentFormContainerProps } from "models/propTypes/documentPropTypes";
import { DocumentFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { useGenericDocumentService } from "serviceHooks";
import EditGenericDocumentForm from "./editGenericDocumentForm";
//#endregion
import * as Yup from "yup";

const EditGenericDocumentFormContainer: ForwardRefRenderFunction<FormHandles, EditGenericDocumentFormContainerProps> = (
  props,
  ref
) => {
  const genericDocumentService = useGenericDocumentService();
  const validationSchema = Yup.object<DocumentFormTypes.EditGenericDocument>({
    name: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const defaultValues = {
    name: "",
  } as DocumentFormTypes.EditGenericDocument;

  const handleEditDocument = React.useCallback(
    (values: DocumentFormTypes.EditGenericDocument) => {
      return genericDocumentService.update(props.documentId, {
        subject: values.name,
      });
    },
    [props.documentId]
  );

  return (
    <EditGenericDocumentForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleEditDocument}
    />
  );
};

export default forwardRef(EditGenericDocumentFormContainer);
